import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b6d5fa8&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4b6d5fa8&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=4b6d5fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d5fa8",
  null
  
)

export default component.exports